import { Route, Switch } from 'react-router-dom';
import CashierDashboardWrapper from '../cashpoint_desktop/cashpoint_wrapper/cashpoint_wrapper';
import MerchantDashboard from '../merchant';

const Admin = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}/merchant`}>
        {/* <AuthGuard>
          <MerchantDashboard />
        </AuthGuard> */}
        <MerchantDashboard />
      </Route>
      <Route path={`${match.path}/cashpoint`}>
        <CashierDashboardWrapper />
        {/* <AuthGuard>
          <CashierDashboardWrapper />
        </AuthGuard> */}
      </Route>
    </Switch>
  );
};

export default Admin;
